var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wbench-process-child"},[_c('div',{staticClass:"child-box"},[_c('div',{staticClass:"child-page"},[_c('szgc-form-getor',{ref:"webReadComponent",attrs:{"edit":_vm.isEdit,"config":_vm.formConfig}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }